import { render, staticRenderFns } from "./AbsenceJustifiedDayLegend.vue?vue&type=template&id=a406d20a&"
import script from "./AbsenceJustifiedDayLegend.vue?vue&type=script&lang=js&"
export * from "./AbsenceJustifiedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a406d20a')) {
      api.createRecord('a406d20a', component.options)
    } else {
      api.reload('a406d20a', component.options)
    }
    module.hot.accept("./AbsenceJustifiedDayLegend.vue?vue&type=template&id=a406d20a&", function () {
      api.rerender('a406d20a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/AbsenceJustifiedDayLegend.vue"
export default component.exports